import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Injector, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { Store } from '@ngrx/store';
import { AbstractComponent, Attendance, AttendanceService, AttendanceStatusEnum, Tag } from 'lib-trend-core';
import { Observable } from 'rxjs';
import { getAttendance, getAttendances } from '../../state/actions';
import { AppState, PagerParamsState } from '../../state/app.state';
import { attendanceSelector, pagerParamsSelector, tagsSelector } from '../../state/selectors';

@Component({
    selector: 'service-tag-attendance',
    templateUrl: './tag-attendance.v2.component.html',
    styleUrls: ['./tag-attendance.v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TagAttendanceComponent extends AbstractComponent implements OnInit, OnDestroy {

  readonly attendance$: Observable<Attendance> = this.store.select(attendanceSelector);
  readonly tags$: Observable<Array<Tag>> = this.store.select(tagsSelector);
  readonly pagerParams$: Observable<PagerParamsState> = this.store.select(pagerParamsSelector);

  separatorKeysCodes: number[] = [ENTER, COMMA];
  tags: Array<Tag> = new Array<Tag>();
  filteredTags: Array<Tag> = new Array<Tag>();
  attendance: Attendance;
  showSelectTags: boolean = true;
  pagerParamsState: PagerParamsState;

  constructor(
    injector: Injector,
    private store: Store<AppState>,
    private attendanceService: AttendanceService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.attendance$.subscribe(attendance => { this.attendance = attendance; });
    this.tags$.subscribe(tags => { this.tags = tags; });
    this.pagerParams$.subscribe(pager => {
      this.pagerParamsState = pager;
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getFilteredList() {
    return this.attendance?.tags;
  }

  selected(event: MatSelectChange): void {
    this.addRemoveTag(event.value._id);
    this.showSelectTags = true;
    event.source.value = null; // Clear the input after selecting an item
  }

  remove(tag: Tag): void {
    this.addRemoveTag(tag._id);
  }

  addRemoveTag(idTag: string) {
    if (this.attendance.status === AttendanceStatusEnum.CLOSED) {
      this.alertService.info(this.t('attendance.tag.cannotEditClosedAttendance'));
      return;
    }

    this.attendanceService.addRemoveTag({ idTag, idAttendance: this.attendance._id }).subscribe({
      next: () => {
        this.alertService.success();
        this.store.dispatch(getAttendance({ idAttendance: this.attendance._id }));
        this.store.dispatch(getAttendances({
          page: this.pagerParamsState.page,
          perPage: this.pagerParamsState.perPage,
          search: this.pagerParamsState.search,
          params: this.pagerParamsState.params,
        }));
      },
      error: (err) => this.alertService.error(err.error.message),
      complete: () => { },
    });
  }

  openSelectTags(): void {
    this.showSelectTags = false;
  }
}
